import { NgModule } from '@angular/core';



import { TableModule } from './table/table.module';
import { PaginationModule } from './pagination/pagination.module';
import { ButtonModule } from './button/button.module';
import { StepsModule } from './steps/steps.module';
import { UploadModule } from './upload/upload.module';
import { AvatarModule } from './avatar/avatar.module';
import { SelectModule } from './select/select.module';
import { CheckboxModule } from './checkbox/checkbox.module';
import { DropDownModule } from './dropdown-search/dropdown.module';
import { TreeSelectModule } from './tree-select/tree-select.module';
import { SelectBoxModule } from './select-box/select-box.module';
import { LayerModule } from './layer/layer.module';
import { JqGridModule } from './jq-grid/grid.module';
import { BgEChartsModule } from './bg-echarts/bg-echarts.module';
import { EChartsOptions } from './bg-echarts/echarts-options';
import { DaterangepickerModule } from './daterangepicker/daterangepicker.module';
import { EditorModule } from './editor/editor.module';
import { UEditorModule } from './ueditor/ueditor.module';



export { TableModule } from './table/table.module';
export { PaginationModule } from './pagination/pagination.module';
export { ButtonModule } from './button/button.module';
export { StepsModule } from './steps/steps.module';
export { UploadModule } from './upload/upload.module';
export { AvatarModule } from './avatar/avatar.module';
export { SelectModule } from './select/select.module';
export { CheckboxModule } from './checkbox/checkbox.module';
export { DropDownModule } from './dropdown-search/dropdown.module';
export { TreeSelectModule } from './tree-select/tree-select.module';
export { SelectBoxModule } from './select-box/select-box.module';
export { LayerModule } from './layer/layer.module';
export { JqGridModule } from './jq-grid/grid.module';
export { BgEChartsModule } from './bg-echarts/bg-echarts.module';
export { EChartsOptions } from './bg-echarts/echarts-options';
export { DaterangepickerModule } from './daterangepicker/daterangepicker.module';
export { UEditorModule } from './ueditor/ueditor.module';
export { EditorModule } from './editor/editor.module';


export { UploadService } from './upload/upload.service';


export const modules = [TableModule, PaginationModule, ButtonModule, StepsModule, UploadModule, AvatarModule, SelectModule, CheckboxModule
  , DropDownModule, TreeSelectModule, SelectBoxModule, LayerModule, JqGridModule, BgEChartsModule, DaterangepickerModule, EditorModule, UEditorModule
]


@NgModule({
  exports: [...modules]
})
export class BangUiModule { }
